import { render } from "./SectionSkeleton.vue?vue&type=template&id=e79f0282"
import script from "./SectionSkeleton.vue?vue&type=script&lang=js"
export * from "./SectionSkeleton.vue?vue&type=script&lang=js"
script.render = render

export default script